import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

const TARGET_URL_KEY = 'PL_401_TARGET_URL';

const targetUrlStorage: Storage = sessionStorage;

export const isNotLoggedIn: CanMatchFn = () => {
  if (!inject(OAuthService).hasValidAccessToken()) {
    storeTargetUrl();
    return true;
  }

  const targetUrl = targetUrlStorage.getItem(TARGET_URL_KEY);
  if (targetUrl) {
    targetUrlStorage.removeItem(TARGET_URL_KEY);
    return inject(Router).parseUrl(targetUrl);
  }
  return false;
};

function storeTargetUrl() {
  // should always be true, but just in case
  if (location.href.startsWith(document.baseURI)) {
    targetUrlStorage.setItem(
      TARGET_URL_KEY,
      location.href.substring(document.baseURI.length),
    );
  }
}
